import { Component, ChangeDetectionStrategy, OnDestroy, OnInit, Injector } from '@angular/core';
import { TranslationService } from './modules/i18n/translation.service';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { locale as idLang } from './modules/i18n/vocabs/id';
import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { SidebarService } from './shared/services/sidebar.service';
import { AuthService } from './shared/services/auth.service';
import { ClientIPAddressService } from './shared/services/client-ip.service';
import { IdbStorageService } from './shared/services/storage/idb-storage.service';
import { setAppInjector } from './shared/utils/app-injector';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { FcmService } from './shared/services/fcm.service';
import { DataCacheStorageService } from './shared/services/storage/data-cache-storage.service';
import { SocketService } from './shared/services/socket/socket.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  public idKaryawan: number;

  constructor(
    public authService: AuthService,
    public clientIpService: ClientIPAddressService,
    public sidebarService: SidebarService,
    public storageService: IdbStorageService,
    public dataCacheStorageService: DataCacheStorageService,
    private afMessaging: AngularFireMessaging,
    private fcmService: FcmService,
    private translationService: TranslationService,
    private splashScreenService: SplashScreenService,
    private socketService: SocketService,
    private router: Router,
    private injector: Injector
  ) {
    // register app injector, used to inject services without constructor.
    setAppInjector(this.injector);

    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang,
      idLang
    );
    this.socketService.init();

    // Register Angular Fire Analytics
    // if (environment.production === true) {
    //   this.authService.authState$.subscribe(async (res) => {
    //     if (res === true) {
    //       const idLogin = await this.storageService.getItem(storageDict.idLogin);
    //       const karyawan = await this.storageService.getItem(storageDict.karyawan);
    //       this.afAnalytics.setUserId(`${idLogin}`);
    //       this.afAnalytics.setUserProperties({
    //         envType: environment.type,
    //         karyawan: karyawan.nama,
    //       });
    //     }
    //   });
    // }

    if (navigator.vendor && navigator.vendor.indexOf('Apple') === -1) {
      // Init Firebase Cloud Messaging (FCM).
      this.fcmService.initListener();
      this.afMessaging.requestToken.subscribe(
        (fcmToken) => {
          this.fcmService.setToken(fcmToken);
        },
        (err) => {}
      );
    }
  }

  ngOnInit() {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const params = new URLSearchParams(event.url.split('#')[1]);
        const redirectId = params.get('redirectId');
        const redirectUrl = params.get('redirectUrl');

        if (redirectId && redirectUrl) {
          // ? Don't close the splash screen if it is an embedded page request.
          // ? It will close when NavigationEnd is on the target embedding page.
          return;
        }

        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
